export * from './delete-herausgeber.component';
export * from './delete-herausgeber.component.module';